module.exports = __webpack_public_path__ + "img/valencia.93214090.jpg";